import React, { Component, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { getApiBaseUrl } from "../utils/apiConfig";
import { encryptData } from "../utils/cryptoHelper";


class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: '',
            password: '',
            errorMessage: '',
            rememberMe: false,
            CompanyInfo: []
        }
    }
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default form submission
            this.handleSubmit(e);
        }
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (e.target.name === "emailAddress") {
            this.setState({
                emailAddress: e.target.value
            });
        } else if (e.target.name === "password") {
            this.setState({
                password: e.target.value
            });
        }
        if (type === 'checkbox') {
            this.setState({ [name]: checked });
        } else {
            this.setState({ [name]: value });
        }

        this.setState({ errorMessage: "" });
    }

    handleSubmit = async (e) => {
        
        let loginDetails = {
            Email: this.state.emailAddress,
            PasswordHash: this.state.password,
            ApplicationId: process.env.REACT_APP_APPLICATION_ID
        };
        // window.addEventListener("storage", (e) => {
        //     if (e.key === "IsLogedIn" && e.newValue === undefined) {
        //       // Perform actions like redirecting to login page
        //       window.location.href = "/login"; // Redirect to login page
        //     }
        //   });
        try {
            const response = await axios.post(getApiBaseUrl() + '/login', loginDetails);
            if (response.status === 200) {
                const storage = this.state.rememberMe ? localStorage : sessionStorage;
                storage.setItem('token', response.data.token);
                storage.setItem('user', response.data.data[0][0].FullName);
                storage.setItem('roleId', response.data.data[0][0].RoleId);
                storage.setItem('userRole', response.data.data[0][0].RoleName);
                storage.setItem('userId', response.data.data[0][0].Id);
                storage.setItem('IsLogedIn', 'true');
                storage.setItem('IsAdmin', response.data.data[0][0].HasAdminRights === 1 ? 'true' : 'false');
                
                let userDetails = {
                    UserId: response.data.data[0][0].Id
                };
                // Fetch permissions after login
                const permissionResponse = await axios.get(
                    getApiBaseUrl() + '/getModulePermissions',
                    { params: userDetails }
                );

                if (permissionResponse.status === 200) {
                    const permissions = permissionResponse.data.data[0];
                    // Store in localStorage or sessionStorage
                    const encryptedPermissions = encryptData(permissions);
                    storage.setItem('userPermissions', JSON.stringify(encryptedPermissions));
                }
                let actionURL;
                if(Number(loginDetails.ApplicationId) === 0){
                    actionURL = response.data.data[0][0].ActionURL ? response.data.data[0][0].ActionURL: '/home/client-environments';
                } else {
                    actionURL = response.data.data[0][0].ActionURL ? response.data.data[0][0].ActionURL: '/home/dashboard';
                }
                this.props.navigate(actionURL);

            } else if(response.status === 201) {
                if(this.state.emailAddress.length === 0 && this.state.password.length === 0){
                    this.setState({ errorMessage: "Please Enter UsersName and Password !!"});
                } else {
                    this.setState({ errorMessage: "User not exists !!"});
                }
            } else if(response.status === 202) {
                if(this.state.emailAddress.length > 0 && this.state.password.length === 0){
                    this.setState({ errorMessage: "Please Enter Password !!"});
                } else {
                    this.setState({ errorMessage: "Unauthorized access !!"});
                }
            } else if(response.status === 203) {
                this.setState({ errorMessage: "Your user name is expired, please contact your authorized person !!"});
            } else if(response.status === 204) {
                this.setState({ errorMessage: "Your user is locked, please contact your Administrator !!"});
            } else if(response.status === 205) {
                this.setState({ errorMessage: "Your user have not assigned modules, please contact your Administrator !!"});
            }
        } catch (error) {
            console.log(error);
        }
        
    }

    clearForm = async () => {
        this.setState({
            emailAddress: '',
            password: ''
        })
    }
    fetchCompanyInfo = async () => {
        try {
          let companyDetails = {
            UserId: 0,
            CompanyId: process.env.REACT_APP_COMPANY_ID
          };
          const response = await axios.get(
            getApiBaseUrl() + "/getCompanyInfo", {params: companyDetails}
          );
          if (response.status === 200) {
            this.setState({
                CompanyInfo: response.data.data[0][0]
            });
          }
        } catch (error) {
          console.log(error);
        }
    };
      
    async componentDidMount() {
        this.fetchCompanyInfo();
        // Development debug auto-login: bypass login when env var is set
        try {
            const debugUserId = process.env.REACT_APP_DEBUG_USER_ID;
            const isDev = process.env.NODE_ENV === 'development';
            // Only auto-login in development builds
            if (debugUserId && isDev) {
                const storage = this.state.rememberMe ? localStorage : sessionStorage;
                const applicationId = Number(process.env.REACT_APP_APPLICATION_ID || 0);
                const resp = await axios.post(getApiBaseUrl() + '/debug-login', { UserId: Number(debugUserId), ApplicationId: applicationId });
                if (resp.status === 200) {
                    storage.setItem('token', resp.data.token);
                    storage.setItem('user', resp.data.data[0][0].FullName);
                    storage.setItem('roleId', resp.data.data[0][0].RoleId);
                    storage.setItem('userRole', resp.data.data[0][0].RoleName);
                    storage.setItem('userId', resp.data.data[0][0].Id);
                    storage.setItem('IsLogedIn', 'true');
                    storage.setItem('IsAdmin', resp.data.data[0][0].HasAdminRights === 1 ? 'true' : 'false');

                    let userDetails = { UserId: resp.data.data[0][0].Id };
                    const permissionResponse = await axios.get(getApiBaseUrl() + '/getModulePermissions', { params: userDetails });
                    if (permissionResponse.status === 200) {
                        const permissions = permissionResponse.data.data[0];
                        const encryptedPermissions = encryptData(permissions);
                        storage.setItem('userPermissions', JSON.stringify(encryptedPermissions));
                    }
                    const appId = applicationId;
                    const actionURL = resp.data.data[0][0].ActionURL ? resp.data.data[0][0].ActionURL : (appId === 0 ? '/home/client-environments' : '/home/dashboard');
                    this.props.navigate(actionURL);
                    return;
                }
            }
        } catch (e) {
            // swallow
        }
        if (this.emailInput) {
            const input = this.emailInput;
            input.focus();

            // Move cursor to the end of the input
            const length = input.value.length;
            input.setSelectionRange(length, length);
        }
    }
    render() {
        return (
            <>
                <div>{ }</div>
                <div className="main-wrapper">
                    <div className="account-content">
                        <div className="login-wrapper">
                            <div className="login-content">
                                <div className="login-userset" style={{ width: "456px" }}>
                                    <div className="login-logo logo-normal">
                                        <img src={"assets/img/" + this.state.CompanyInfo.LogoImagePath} alt="img" />
                                    </div>
                                    <Link to="/login" className="login-logo logo-white">
                                        <img src="assets/img/logo-white.png" alt="" />
                                    </Link>
                                    <div className="login-userheading">
                                        <h3>Sign In</h3>
                                        <h4 style={{ color: "red",fontSize: "big"}}>{this.state.errorMessage}</h4>
                                    </div>
                                    <div className="form-login">
                                        <label>Email Address</label>
                                        <div className="form-addons">
                                            <input
                                                type="text" className="form-control"
                                                name="emailAddress"
                                                value={this.state.emailAddress}
                                                onChange={this.handleChange}
                                                onKeyDown={this.handleKeyDown}
                                                ref={(input) => { this.emailInput = input; }}
                                            />
                                            <img src="assets/img/icons/mail.svg" alt="img" />
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <label>Password</label>
                                        <div className="pass-group">
                                            <input
                                                type="password" className="pass-input"
                                                name="password"
                                                value={this.state.password}
                                                onChange={this.handleChange}
                                                onKeyDown={this.handleKeyDown}
                                            />
                                            <span className="fas toggle-password fa-eye-slash"></span>
                                        </div>
                                    </div>
                                    {/* <div className="form-login authentication-check">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="custom-control custom-checkbox">
                                                    <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                                                        <input
                                                            type="checkbox"
                                                            name="rememberMe"
                                                            checked={this.state.rememberMe}
                                                            onChange={this.handleChange}
                                                        />
                                                        <span className="checkmarks"></span>Remember me
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-6 text-end">
                                                <Link className="forgot-link" to="/">Forgot Password?</Link>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="form-login">
                                        <button type="submit"
                                            onClick={this.handleSubmit}
                                            className="btn btn-login"
                                        >Sign In</button>
                                    </div>
                                    {/* <div className="signinform">
                                        <h4>New on our platform?<Link to="/registeruser" className="hover-a"> Create an account</Link></h4>
                                    </div> */}
                                    {/* <div className="form-setlogin or-text">
                                            <h4>OR</h4>
                                        </div>
                                         <div className="form-sociallink">
                                            <ul className="d-flex">
                                                <li>
                                                    <Link to="/" className="facebook-logo">
                                                        <img src="assets/img/icons/facebook-logo.svg" alt="Facebook"/>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/">
                                                        <img src="assets/img/icons/google.png" alt="Google"/>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/" className="apple-logo">
                                                        <img src="assets/img/icons/apple-logo.svg" alt="Apple"/>
                                                    </Link>
                                                </li>
                                            </ul>
                                            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                                                <p>Copyright &copy; 2023 DreamsPOS. All rights reserved</p>
                                            </div>
                                        </div>  */}
                                </div>
                            </div>
                            <div className="login-img">
                                <img src="assets/img/authentication/login02.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}
function addHookTo(Component) {
    function CompWithHook(props) {
        const navigate = useNavigate();

        return <Component {...props} navigate={navigate} />;
    }

    return CompWithHook;
}

export default addHookTo(Login);